module.exports = __webpack_public_path__ + "img/checklist-preview-image.5391a94.jpg";